let _getDashboardType = function () {
  try {
    // add other roles for other enviroments
    let domains = window.location.hostname.split('.')
    let socialkit = domains.find(d => {
      return (d.search(/socialkit/gmi) >= 0 || d.search(/nerds/gmi) >= 0)
    })

    let banorte = domains.find(d => {
      return d.search(/banorte/gmi) >= 0
    })

    if (socialkit) return 'socialkit'
    if (banorte) return 'banorte'
  } catch (e) {}

  return 'konverza'
}

let _getDashboardTitle = function (type) {
  switch (type) {
    case 'konverza':
      return 'Konverza'
      break
    case 'socialkit':
      return 'Artificial Nerds'
      break
    case 'banorte':
      return 'Banorte Comercios'
      break
    default:
      return 'Artificial Nerds'
  }
}

let _getDashboardLogo = function (type) {
  switch (type) {
    case 'socialkit':
      return "@/assets/socialkit_logo.png"
    case 'banorte':
      return '@/assets/banorte_logo.png'
    default:
      return "@/assets/konverza_logo.png"
  }
}

export const getDashboardType  = _getDashboardType
export const getDashboardTitle = _getDashboardTitle
export const getDashboardLogo = _getDashboardLogo

export default {
  install (Vue, options) {
    Vue.mixin({
      data () {
        return {
          dashboardTitle: 'Artificial Nerds',
          dashboardType: 'botlers',
          dashboardLogo: "@/assets/an_logo.png"
        }
      },
      created () {
        this.dashboardType = _getDashboardType()
        this.dashboardTitle = _getDashboardTitle(this.dashboardType)
        this.dashboardLogo = _getDashboardLogo(this.dashboardType)
      }
    })
  }
}
